import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import HotNewsBar from './components/HotNewsBar';
import CategoryTabs from './components/CategoryTabs';
import ArticleGrid from './components/ArticleGrid';
import Sidebar from './components/Sidebar';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import { articles } from '@/mocks/articles';

const latestArticles = articles.filter((a) => a.isNew).slice(0, 6);
const hotArticles = articles.filter((a) => a.isHot).slice(0, 6);
const allArticles = articles.slice(0, 9);

export default function Home() {
  useEffect(() => {
    document.title = '51cg吃瓜网 - 51cg.fun黑料吃瓜网 | 51cg莫里秀找爹爆料内幕在线观看';
  }, []);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '51cg吃瓜网',
    url: 'https://51cg.fun',
    description: '51cg吃瓜网、51cg.fun黑料吃瓜网专题，收录51cg莫里秀全集、找爹视频与51cg爆料内幕，提供51cg黑料合集与情感八卦内容。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://51cg.fun/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51cg吃瓜网',
    url: 'https://51cg.fun',
    description: '国内领先的娱乐八卦与热点资讯聚合平台',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@51cg.fun',
      contactType: 'customer service',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <HotNewsBar />
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <CategoryTabs />

          <div className="py-8 md:py-10">
            <ArticleGrid
              title="最新爆料"
              articles={latestArticles.length > 0 ? latestArticles : allArticles.slice(0, 6)}
            />
          </div>

          <div className="pb-8 md:pb-10">
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="flex-1">
                <ArticleGrid
                  title="热门推荐"
                  articles={hotArticles.length > 0 ? hotArticles : allArticles.slice(6, 9)}
                />
              </div>
              <div className="w-full lg:w-80 flex-shrink-0">
                <Sidebar />
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}